import { C_PROPERTY_ORDER_BY } from "@/src-refactor/modules/shared/model/const/property-order-by.conts";
import { HGetKeyEnums } from "@rf-helper/generat-enums-from-keys";
import { useFilterParams } from "@rf-hooks/useFilterParams";
import { SchemaItemGeneric } from "@rf/schemas/item-generic.shema";
import { array, boolean, InferType, number, object, string } from "@yup";

export const PropertyListFilterSchema = object({
  search: string().default(""),
  city: array().of(SchemaItemGeneric).default([]),
  sector: array().of(SchemaItemGeneric).default([]),
  currencySale: array().of(SchemaItemGeneric).default([]),
  priceMin: string().isNumeric().default(""),
  priceMax: string()
    .isNumeric()
    .default("")
    .test(
      "priceMax",
      "El precio máximo debe ser mayor o igual al precio mínimo",
      function (value) {
        return +value >= +this.parent.priceMin;
      }
    ),
  myProperties: boolean().default(false),
  businessType: array().of(SchemaItemGeneric).default([]),
  detailType: array().of(SchemaItemGeneric).default([]),
  status: array().of(SchemaItemGeneric).default([]),
  percentCommission: string().isNumeric().default(""),
  metersLandMax: string().isNumeric().default(""),
  metersLandMin: string().isNumeric().default(""),
  metersConstructionMax: string().isNumeric().default(""),
  metersConstructionMin: string().isNumeric().default(""),
  maintenanceMax: string().isNumeric().default(""),
  maintenanceMin: string().isNumeric().default(""),
  maintenanceCurrency: array().of(SchemaItemGeneric).default([]),
  condition: array().of(SchemaItemGeneric).default([]),
  type: array().of(SchemaItemGeneric).default([]),
  bedroom: array().default([]),
  bathroom: array().default([]),
  halfBathroom: array().default([]),
  parking: array().default([]),
  levelFloor: array().default([]),
  improvements: array().of(SchemaItemGeneric).default([]),
  agencies: array().of(SchemaItemGeneric).default([]),
  agents: array().of(SchemaItemGeneric).default([]),
  masterBroker: boolean().default(false),
  fideicomiso: array().of(SchemaItemGeneric).default([]),
  page: number().default(1),
  isCollection: boolean().default(false),
  deliveryDate: string().default(""),
  orderBy: array().of(SchemaItemGeneric).default([C_PROPERTY_ORDER_BY.MOST_RECENT]),
  area: string().default(""),
  createdAt: string().default("")
});

export type IPropertyListFilterSchema = InferType<typeof PropertyListFilterSchema>;
export const CPropertyListFilter: IPropertyListFilterSchema =
  PropertyListFilterSchema.getDefault();
export const CPropertyListFilterKeys = HGetKeyEnums(CPropertyListFilter) as {
  [K in keyof typeof CPropertyListFilter]: K;
};
// Example usage for PropertyList
// export const usePropertyListFilters = () => {
//   return useFilterParams({
//     paramName: "property-filters"
//   });
// };
